// extracted by mini-css-extract-plugin
export var menuIcon = "_py-0";
export var menuIconInline = "_py-1";